<div class="file-upload-wrapper" (drop)="onFileDrop($event)" (dragover)="onDragOver($event)">
  <input type="file"
         accept="image/*" (change)="onFileChange($event)" hidden #fileInput />

  <div class="file-dropper" (click)="triggerFileInput()">
    <img ngSrc="assets/images/image-upload.png" height="80" width="80" alt="uploaded image"/>
  </div>
</div>
